"use client";
import { ReactElement, useEffect, useState } from "react";
import { DeliveryOptionsResponse } from "@repo/apis/commerce-deliveryoptions-v2";
import { useStore } from "@repo/ui/store";
import { clientRequest } from "@/utils/request-adapters/client-request";
import { SimpleSheet } from "../../components/simple-sheet";
import { getDeliveryAndReturnsData } from "./api";
import { DeliveryAndReturnsContent } from "./content";
import classes from "./index.module.css";

const ClientContent = () => {
  const { countryData } = useStore();
  const [deliveryAndReturnsData, setDeliveryAndReturnsData] = useState(
    null as DeliveryOptionsResponse | null,
  );

  useEffect(() => {
    if (deliveryAndReturnsData) {
      return;
    }

    getDeliveryAndReturnsData({
      requestInstance: clientRequest,
      countryData,
    }).then((data: DeliveryOptionsResponse) => {
      setDeliveryAndReturnsData(data);
    });
  }, [deliveryAndReturnsData, countryData]);

  if (!deliveryAndReturnsData) {
    //todo: what should we do here? or when we catch the above?
    return null;
  }

  return (
    <div className={classes.scrollable}>
      <DeliveryAndReturnsContent
        deliveryAndReturnsData={deliveryAndReturnsData}
        lang={countryData.defaultLanguage}
      />
    </div>
  );
};

export const DeliveryAndReturnsSheetView = ({
  children,
  className,
}: {
  children?: string | ReactElement;
  className?: string;
}) => {
  return (
    <SimpleSheet
      trigger={children}
      title="Delivery & Returns"
      description="Check out our delivery and returns options"
      triggerClassName={className}
      position="right"
      triggerHref={`/delivery-and-returns`}
    >
      <ClientContent />
    </SimpleSheet>
  );
};
